import React, { useEffect, useCallback } from "react";
import styles from "./cards.module.scss";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";
import biometricsImage from "Assets/images/biometrics_card_image.webp";
import { trackEvent } from "utility/mixpanel";
import { useInViews } from "utility/useInViews";

const BiometricsCard = ({ onOpen }) => {
  const { ref, inView } = useInViews();
  const { t } = useTranslation(["components"]);

  const logImpression = useCallback(() => {
    trackEvent("Biometrics Card Viewed", {
      "Page Title": document.title,
      "Page Path": window.location.pathname,
    });
  }, []);

  useEffect(() => {
    if (inView) {
      logImpression();
    }
  }, [inView, logImpression]);

  const handleConnectClick = () => {
    trackEvent("Biometrics Connect Device Clicked", {
      "Page Title": document.title,
      "Page Path": window.location.pathname,
    });

    onOpen();
  };

  return (
    <div className={styles["biometrics-card"]} ref={ref}>
      <img
        src={biometricsImage}
        alt="Biometrics"
        className={styles["biometrics-card-image"]}
      />
      <div className={styles["biometrics-card-details"]}>
        <p className={styles["biometrics-card-title"]}>
          {t("components:biometricsCard.title")}
        </p>
        <p className={styles["biometrics-card-description"]}>
          {t("components:biometricsCard.body")}
        </p>
        <Button variant="enclosed-primary" onClick={handleConnectClick}>
          {t("components:biometricsCard.cta")}
        </Button>
      </div>
    </div>
  );
};

export default BiometricsCard;
